import React from 'react';
import { FormGroup } from '@prism/form';
import { withFormsy } from 'formsy-react';
import PrismRadioButton from './../radioButton/prismRadioButton';
import PropTypes from 'prop-types';

class FormsyPrismRadioGroup extends React.PureComponent {
    static propTypes = {
        defaultValue: PropTypes.object,
        getValue: PropTypes.func.isRequired,
        setValue: PropTypes.func.isRequired,
        isPristine: PropTypes.func.isRequired,
        options: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.any
        })).isRequired,
        onChange: PropTypes.func,
        row: PropTypes.bool
    }

    constructor(props) {
        super(props);

        this.state = {
            value: props.getValue()
        }
    }

    onChange = (value) => {
        this.setState({
            value: value
        });
        this.props.setValue(value);

        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };

    render() {
        const { options, getValue, value: defaultValue, isPristine, row } = this.props;
        const value = isPristine() ? defaultValue : getValue();

        return (
            <div className="prism-sandbox">
                <FormGroup row={row}>
                    {options.map(option => <PrismRadioButton
                        key={option.value}
                        value={option.value}
                        label={option.label}
                        className={option.className}
                        checked={value === option.value}
                        onChange={() => { this.onChange(option.value) }} />)}
                </FormGroup>
            </div>
        )
    }
}

export default withFormsy(FormsyPrismRadioGroup);
